import { Search, X } from 'lucide-react';

export function CardSearchBar({ value = '', onChange, placeholder = 'Search any card data… e.g. obf, char, holo, -ex', testid = 'search-input' }) {
  return <div className="relative">
    <Search aria-hidden="true" className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
    <input type="search" aria-label="Search" value={value} onChange={event => onChange(event.target.value)}
      placeholder={placeholder} data-testid={testid}
      title="Spaces and commas mean AND; -term means NOT. Use quotes for phrases."
      className="h-14 w-full rounded-full border border-slate-200 bg-slate-50 pl-12 pr-12 text-lg outline-none focus:border-[#E3350D] focus:ring-2 focus:ring-[#E3350D]/20 [&::-webkit-search-cancel-button]:appearance-none" />
    {!!value && <button type="button" aria-label="Clear search" onClick={() => onChange('')} className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-2 text-slate-500 hover:bg-slate-200"><X className="h-4 w-4" /></button>}
  </div>;
}
